const animateGSAPModules = [
    {
        selector: '[data-load-animation]',
        path: { dirname: 'animations', filename: 'loadGSAPAnimation' },
    },
];

const animateLottieElements = [
    {
        selector: '[data-lottie-src]',
        path: { dirname: 'animations', filename: 'animateLottieElements' },
    },
];

export { animateGSAPModules, animateLottieElements };
